import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSubheader } from 'vuetify/lib/components/VSubheader';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',[_c(VNavigationDrawer,{attrs:{"app":_vm.app,"permanent":"","clipped":_vm.clipped,"light":"","width":"320"}},[_c(VRow,{staticClass:"fill-height",attrs:{"no-gutters":""}},[_c(VList,{staticClass:"grow"},[_c(VSubheader,[_vm._v("Chapters")]),_vm._l((_vm.help),function(item,index){return [_c(VListItem,{key:index,class:`pl-${item.depth * 6}`,attrs:{"to":item.route,"exact":item.exact}},[_c(VListItemContent,[_c(VListItemTitle,[_vm._v(_vm._s(item.title))])],1)],1)]})],2)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }